import React from "react";
import { Link } from "gatsby";

export const DesktopGalleriesLinks = ({
  data,
  activeInnerMenu,
  setActiveInnerMenu,
  setActiveMenuHeight,
}) => {
  const galleriesLinks = data
    .filter((link) => link.primary.page.document !== null)
    .filter((link) => link.primary.page.document.data?.title?.text) // Ajouter ce filtre
    .map((link, index) => {
      const url = link.primary.page.document.url || link.primary.page.url;

      console.log("Link data:", link.primary.page);
      console.log("Document URL:", link.primary.page.document?.url);
      console.log("Page URL:", link.primary.page.url);

      return (
        <li
          key={`single_galleries_section_${index}`}
          className="classico single-link-section"
        >
          <Link to={url}>{link.primary.page.document.data.title.text}</Link>
        </li>
      );
    });

  return galleriesLinks;
};
